import { transformLayers } from './transformLayers';

export const getPrototypeInitialState = ({
  filePage,
  currentInitialState,
}: {
  filePage: any;
  currentInitialState: any;
}) => {
  const layers = filePage.children;

  const initialState = {
    preview: null as any,
    componentsLayer: null as any,
    layers: transformLayers({
      layers,
      currentLayers: currentInitialState ? currentInitialState.layers : [],
      parent: null,
    }),
  };

  return initialState;
};
